import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../colors';

const StyledMemberRow = styled('div')({
  background: Colors.white,
  border: '1px solid var(--green)',
  borderRadius: '20px',
  boxShadow: '0px 4px 15px rgba(62, 164, 72, 0.1)',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '20rem',
  height: '4rem',
  paddingLeft: '20px',
  position: 'relative',
  '&:hover': {
    cursor: 'pointer',
    transform: 'scale(1.02)',
    boxShadow: '0px 8px 15px rgba(62, 164, 72, 0.1)',
  },
  '&:active': {
    background: 'var(--light-gray)',
  },
});

const StyledEditIcon = styled(EditIcon)({
  color: 'var(--blue)',
  marginRight: '1rem',
});

function MemberRow({
  member,
  onClickEdit,
}) {
  return (
    <StyledMemberRow onClick={onClickEdit}>
      {member.firstName} {member.lastName}
      <StyledEditIcon />
    </StyledMemberRow>
  );
};

export default MemberRow;
